import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('calc-slider')
export class CalcSlider extends LitElement {
    @property({ type: String }) labelId = '';
    @property({ type: String }) label = '';
    @property({ type: Number, reflect: true }) value = 0;
    @property({ type: String }) unit = '';
    @property({ type: Number }) min = 0;
    @property({ type: Number }) max = 100;
    @property({ type: Number }) step = 1;

    createRenderRoot() {
        return this;
    }

    updated(changedProperties: Map<string, any>) {
        super.updated(changedProperties);
        if (changedProperties.has('value') || changedProperties.has('min') || changedProperties.has('max')) {
            const input = this.querySelector('input[type="range"]') as HTMLInputElement;
            if (input && input.value !== String(this.value)) {
                input.value = String(this.value);
            }
            if (input) {
                this.updateSliderBackground(input);
            }
        }
    }

    firstUpdated() {
        const input = this.querySelector('input[type="range"]') as HTMLInputElement;
        if (input) {
            this.updateSliderBackground(input);
        }
    }

    private updateSliderBackground(range: HTMLInputElement) {
        const val = (Number(range.value) - Number(range.min)) / (Number(range.max) - Number(range.min));    
        range.style.backgroundImage = '-webkit-gradient(linear, left top, right top, ' + 'color-stop(' + val + ', #232322), ' + 'color-stop(' + val + ', #EAE9E8)' +')';
    }

    render() {
        const value = this.value ?? 0;
        const displayValue = this.unit === '%' ? `${value} ${this.unit}` : `${value.toLocaleString('sv-SE')} ${this.unit}`;
        
        return html`
            <div class="">
                <div class="flex justify-between items-center">
                    <label for="${this.labelId}" class="preamble mb-0">${this.label}</label>
                    <span class="preamble">${displayValue}</span>
                </div>
                <input
                    id="${this.labelId}" 
                    type="range" 
                    class="w-full custom-range" 
                    value=${String(value)} 
                    min=${String(this.min)}
                    max=${String(this.max)}
                    step=${String(this.step)}
                    @input=${this.onInput}
                />
                <div class="flex justify-between mb-10 text-price small">
                    <span>${this.min.toLocaleString('sv-SE')}</span>
                    <span>${this.max.toLocaleString('sv-SE')}</span>
                </div>
            </div>
        `;
    }

    private onInput(e: Event) {
        const input = e.target as HTMLInputElement;
        const value = Number(input.value);
        this.value = value;
        this.updateSliderBackground(input);
        this.dispatchEvent(new CustomEvent('value-change', {
            detail: value,
            bubbles: true,
            composed: true
        }));
    }
}